/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ImageModel } from './ImageModel';
import {
    ImageModelFromJSON,
    ImageModelFromJSONTyped,
    ImageModelToJSON,
} from './ImageModel';
import type { UserModel } from './UserModel';
import {
    UserModelFromJSON,
    UserModelFromJSONTyped,
    UserModelToJSON,
} from './UserModel';

/**
 * コミチプラスでの単行本情報の概要です。
 * @export
 * @interface StoreItemSummaryModel
 */
export interface StoreItemSummaryModel {
    /**
     * コミチ内で単行本に付与される一意のID
     * @type {number}
     * @memberof StoreItemSummaryModel
     */
    id: number;
    /**
     * タイトル
     * @type {string}
     * @memberof StoreItemSummaryModel
     */
    title: string;
    /**
     * コミチ内で作品に付与される一意のID
     * @type {string}
     * @memberof StoreItemSummaryModel
     */
    seriesId?: string;
    /**
     * コミチ内で作品に付与される一意のタイトル
     * @type {string}
     * @memberof StoreItemSummaryModel
     */
    seriesTitle?: string;
    /**
     * 単行本のタイプ
     * @type {number}
     * @memberof StoreItemSummaryModel
     */
    type?: number;
    /**
     * 単行本のほかの名
     * @type {string}
     * @memberof StoreItemSummaryModel
     */
    otherName?: string;
    /**
     * 単行本のリンク
     * @type {string}
     * @memberof StoreItemSummaryModel
     */
    url?: string;
    /**
     * 雑誌の名
     * @type {string}
     * @memberof StoreItemSummaryModel
     */
    magazineName?: string;
    /**
     * 雑誌のリンク先
     * @type {string}
     * @memberof StoreItemSummaryModel
     */
    magazineUrl?: string;
    /**
     * 単行本の概要説明
     * @type {string}
     * @memberof StoreItemSummaryModel
     */
    description?: string;
    /**
     * 単行本の概要説明タイプ
     * @type {number}
     * @memberof StoreItemSummaryModel
     */
    descriptionType?: number;
    /**
     * フォローユーザに単行本情報や新着情報をメールの送信が実施済みかを管理するフラグ
     * @type {boolean}
     * @memberof StoreItemSummaryModel
     */
    isMailSent: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StoreItemSummaryModel
     */
    enabled?: boolean;
    /**
     * 試し読みのリンク
     * @type {string}
     * @memberof StoreItemSummaryModel
     */
    trialComiciUrl?: string;
    /**
     * 他の試し読みのリンク
     * @type {string}
     * @memberof StoreItemSummaryModel
     */
    trialOtherUrl?: string;
    /**
     * 状態
     * @type {number}
     * @memberof StoreItemSummaryModel
     */
    status?: number;
    /**
     * 
     * @type {ImageModel}
     * @memberof StoreItemSummaryModel
     */
    image?: ImageModel;
    /**
     * 
     * @type {UserModel}
     * @memberof StoreItemSummaryModel
     */
    user: UserModel;
    /**
     * 発行日のUNIX時間
     * @type {number}
     * @memberof StoreItemSummaryModel
     */
    publishStartOn?: number;
    /**
     * 発行終了日のUNIX時間
     * @type {number}
     * @memberof StoreItemSummaryModel
     */
    publishEndOn?: number;
}

/**
 * Check if a given object implements the StoreItemSummaryModel interface.
 */
export function instanceOfStoreItemSummaryModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "isMailSent" in value;
    isInstance = isInstance && "user" in value;

    return isInstance;
}

export function StoreItemSummaryModelFromJSON(json: any): StoreItemSummaryModel {
    return StoreItemSummaryModelFromJSONTyped(json, false);
}

export function StoreItemSummaryModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreItemSummaryModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'seriesId': !exists(json, 'seriesId') ? undefined : json['seriesId'],
        'seriesTitle': !exists(json, 'seriesTitle') ? undefined : json['seriesTitle'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'otherName': !exists(json, 'otherName') ? undefined : json['otherName'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'magazineName': !exists(json, 'magazineName') ? undefined : json['magazineName'],
        'magazineUrl': !exists(json, 'magazineUrl') ? undefined : json['magazineUrl'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'descriptionType': !exists(json, 'descriptionType') ? undefined : json['descriptionType'],
        'isMailSent': json['isMailSent'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'trialComiciUrl': !exists(json, 'trialComiciUrl') ? undefined : json['trialComiciUrl'],
        'trialOtherUrl': !exists(json, 'trialOtherUrl') ? undefined : json['trialOtherUrl'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'image': !exists(json, 'image') ? undefined : ImageModelFromJSON(json['image']),
        'user': UserModelFromJSON(json['user']),
        'publishStartOn': !exists(json, 'publishStartOn') ? undefined : json['publishStartOn'],
        'publishEndOn': !exists(json, 'publishEndOn') ? undefined : json['publishEndOn'],
    };
}

export function StoreItemSummaryModelToJSON(value?: StoreItemSummaryModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'seriesId': value.seriesId,
        'seriesTitle': value.seriesTitle,
        'type': value.type,
        'otherName': value.otherName,
        'url': value.url,
        'magazineName': value.magazineName,
        'magazineUrl': value.magazineUrl,
        'description': value.description,
        'descriptionType': value.descriptionType,
        'isMailSent': value.isMailSent,
        'enabled': value.enabled,
        'trialComiciUrl': value.trialComiciUrl,
        'trialOtherUrl': value.trialOtherUrl,
        'status': value.status,
        'image': ImageModelToJSON(value.image),
        'user': UserModelToJSON(value.user),
        'publishStartOn': value.publishStartOn,
        'publishEndOn': value.publishEndOn,
    };
}

